import React, { Suspense, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import Modal from 'react-modal';
import { useLocation, useNavigate } from 'react-router-dom';
import { getApi } from '../../../Services/apiService';
import AddVenueModal from './addVenue';
import DeleteModal from './deleteVenue';
import EditVenueModal from './editVenue';

export default function Venue() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('All');
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [addVenueModal, setAddVenueModal] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(100); // default

  const categories = [
    { id: 'All', name: 'All' },
    { id: '1', name: 'Restaurant' },
    { id: '2', name: 'Bar' },
    { id: '3', name: 'Club' },
    { id: '4', name: 'City Attraction' },
    { id: '5', name: 'Hostel' },
    { id: '6', name: 'Experience' },
  ];

  const openAddModal = () => setAddVenueModal(true);
  const openDeleteUserModal = (venue) => {
    setSelectedVenue(venue);
    setDeleteModal(true);
  };
  const openEditVenueModal = (venue) => {
    setSelectedVenue(venue);
    setEditModal(true);
  };

  const fetchVenues = async () => {
    setLoading(true);
    setError(null);

    try {
      const endpoint = activeCategory === 'All'
        ? `/admin/category?search=${searchTerm}&page=${currentPage + 1}&limit=${itemsPerPage}`
        : `/admin/category?type=${activeCategory}&search=${searchTerm}&page=${currentPage + 1}&limit=${itemsPerPage}`;

      const response = await getApi(endpoint);

      if (response?.status === 200) {
        const apiData = response.data;
        setVenues(apiData.data || []);
        setTotalPages(apiData.pagination?.totalPages || 1);
        setTotalItems(apiData.pagination?.totalItems || 0);
      } else {
        throw new Error('Failed to fetch venues.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVenues();
  }, [activeCategory, searchTerm, currentPage, itemsPerPage]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  return (
    <>
      {loading && <div className="loader"><div className="spinner"></div></div>}
      {error && <p className="error-message">{error}</p>}

      <div className={`${location.pathname.includes('venue') ? 'RightSideDiv' : ''} ${loading ? 'blurred' : ''}`}>
        <div className='car-care-tips'>
          <div className="header">
            <h1>Venue</h1>
            <div className="top-right">
              <div className="right-top-search">
                <input
                  type="text"
                  placeholder="Search..."
                  autoComplete="off"
                  className="search-input"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(0);
                  }}
                />
              </div>
  
              <div className="add-new-btn">
                <button className="add-new" onClick={openAddModal}>
                  <img src={window.getPublicUrl("/assets/images/add-plus.svg")} alt="" /> Add new
                </button>
              </div>
            </div>
          </div>

          <ul>
            {categories.map((category) => (
              <li
                key={category.id}
                className={activeCategory === category.id ? 'active' : ''}
                onClick={() => {
                  setActiveCategory(category.id);
                  setCurrentPage(0);
                }}
              >
                <h5>{category.name}</h5>
              </li>
            ))}
          </ul>

          <div className='row'>
            {!loading && !error ? (
              venues.length > 0 ? (
                venues.map((venue) => (
                  <div className='col-sm-3' key={venue.id}>
                    <div className='car-container'>
                      <div className='card' onClick={() => navigate(`detail/${venue.id}`)}>
                        {venue.banner_image ? (
                          <img src={venue.banner_image} alt={venue.name} className='venue-image' />
                        ) : (
                          <p>No image available</p>
                        )}
                      </div>
                      <div className="car-text">
                        <div className="bottom-section">
                          <h3>{venue.name}</h3>
                          <h6>{venue?.location}</h6>
                          <div className="buttons">
                            <span onClick={() => navigate(`detail/${venue.id}`)}>
                              <img src={window.getPublicUrl("/assets/images/view.svg")} alt="" />
                            </span>
                            <button className="edit" onClick={() => openEditVenueModal(venue)}>
                              <img src={window.getPublicUrl("/assets/images/edit.svg")} alt="" />
                            </button>
                            <button className="delete" onClick={() => openDeleteUserModal(venue)}>
                              <img src={window.getPublicUrl("/assets/images/delete.svg")} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-sm-12">
                  <div className='alert alert-danger'>No venues found.</div>
                </div>
              )
            ) : null}
          </div>
        
          {totalPages > 1 && (
  <div className="pagination-wrapper">
    {/* Items Per Page Selector */}
    <div className="items-per-page">
      <label htmlFor="itemsPerPage">Items per page:</label>
      <select
        id="itemsPerPage"
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(parseInt(e.target.value));
          setCurrentPage(0); // Reset to first page
        }}
      >
        {[50, 100, 200, 500].map((count) => (
          <option key={count} value={count}>{count}</option>
        ))}
      </select>
    </div>

    {/* Pagination Controls */}
    <div className="pagination-container">
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={2}
        marginPagesDisplayed={0}
        pageCount={totalPages}
        previousLabel="<"
        containerClassName="pagination"
        pageLinkClassName="page-num"
        previousLinkClassName="page-num"
        nextLinkClassName="page-num"
        activeLinkClassName="active"
        disabledClassName="disabled"
        forcePage={currentPage}
      />

      {/* Optional Pagination Info */}
      {/* <div className="pagination-info">
        Showing {(currentPage * itemsPerPage) + 1} to {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems} items
      </div> */}
    </div>
  </div>
)}

        </div>
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <Modal isOpen={addVenueModal} onRequestClose={() => setAddVenueModal(false)} contentLabel="Add Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
          overlayClassName={`modal-overlay add-venue `}
          portalClassName="add-user venuue">
          <AddVenueModal setAddVenueModal={setAddVenueModal} fetchVenues={fetchVenues} />
        </Modal>
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Modal isOpen={editModal} onRequestClose={() => setEditModal(false)} contentLabel="Edit Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
          overlayClassName={`modal-overlay edit-venue `}
          portalClassName="edit-user venuue">
          <EditVenueModal setEditModal={setEditModal} venueDetails={selectedVenue} fetchVenues={fetchVenues} />
        </Modal>
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
          overlayClassName={`modal-overlay add-category delete logout `}
          portalClassName="add-user deactivate">
          <DeleteModal setDeleteModal={setDeleteModal} venueDetails={selectedVenue} fetchVenues={fetchVenues} />
        </Modal>
      </Suspense>
    </>
  );
}
